module.exports = __webpack_public_path__ + "static/media/1017077.2478d8a0.png";